import { html } from 'fxjs/es';

export const PRODUCT_BADGE_TYPE = {
  real: 'real',
  sold_out: 'sold_out',
  coming: 'coming',
  sell_close: 'sell_close',
  sell_at: 'sell_at',
  limit: 'limit',
  nft: 'nft',
};

export const CUSTOM_IMAGE_FOLDER_NAME = 'custom_image_folder_name';
export const CUSTOM_ALL_FOLDER_NAME = 'all';

export const shippingPriceIcon = () => {
  return html`<svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
    <g clip-path="url(#clip0_3795_8898)">
      <path
        d="M3.91406 10.1996C4.56769 10.1996 5.09756 9.66969 5.09756 9.01606C5.09756 8.36243 4.56769 7.83256 3.91406 7.83256C3.26043 7.83256 2.73056 8.36243 2.73056 9.01606C2.73056 9.66969 3.26043 10.1996 3.91406 10.1996Z"
        fill="#9F9F9F"
      />
      <path
        d="M9.06209 10.1996C9.71572 10.1996 10.2456 9.66969 10.2456 9.01606C10.2456 8.36243 9.71572 7.83256 9.06209 7.83256C8.40846 7.83256 7.87859 8.36243 7.87859 9.01606C7.87859 9.66969 8.40846 10.1996 9.06209 10.1996Z"
        fill="#9F9F9F"
      />
      <path
        d="M8.09456 7.68406V1.79956H1.10156L1.10156 9.01606H2.26706C2.26706 8.10706 3.00506 7.36906 3.91406 7.36906C4.82306 7.36906 5.56106 8.10706 5.56106 9.01606H7.40606C7.40606 8.46706 7.68056 7.98106 8.09456 7.67956V7.68406Z"
        fill="#9F9F9F"
      />
      <path
        d="M9.99808 3.99406H8.60308V7.44106C8.74708 7.40056 8.89558 7.37356 9.05308 7.37356C9.96208 7.37356 10.7001 8.11156 10.7001 9.02056H11.9016V5.89756L9.99808 3.99406Z"
        fill="#9F9F9F"
      />
    </g>
    <defs>
      <clipPath id="clip0_3795_8898">
        <rect width="12" height="12" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>`;
};
